var map = {
	"./link/Pricing": [
		"c259",
		"chunk-2d216409"
	],
	"./link/Pricing.vue": [
		"c259",
		"chunk-2d216409"
	],
	"./link/SetPlace": [
		"bbbb",
		"chunk-2d21a976"
	],
	"./link/SetPlace.vue": [
		"bbbb",
		"chunk-2d21a976"
	],
	"./link/Statistics": [
		"a888",
		"chunk-2d20922d"
	],
	"./link/Statistics.vue": [
		"a888",
		"chunk-2d20922d"
	],
	"./paglierani/Confirmations": [
		"5901",
		"chunk-183e6eca",
		"chunk-703df3ba"
	],
	"./paglierani/Confirmations.vue": [
		"5901",
		"chunk-183e6eca",
		"chunk-703df3ba"
	],
	"./paglierani/Details": [
		"48ce",
		"chunk-183e6eca",
		"chunk-076fa5e2"
	],
	"./paglierani/Details.vue": [
		"48ce",
		"chunk-183e6eca",
		"chunk-076fa5e2"
	],
	"./paglierani/DetailsPrint": [
		"e533",
		"chunk-5870e103"
	],
	"./paglierani/DetailsPrint.vue": [
		"e533",
		"chunk-5870e103"
	],
	"./paglierani/OperativeDetails": [
		"e3b6",
		"chunk-183e6eca",
		"chunk-e1d22f6e"
	],
	"./paglierani/OperativeDetails.vue": [
		"e3b6",
		"chunk-183e6eca",
		"chunk-e1d22f6e"
	],
	"./paglierani/PaglieraniPrintHeader": [
		"5727",
		"chunk-57c69305"
	],
	"./paglierani/PaglieraniPrintHeader.vue": [
		"5727",
		"chunk-57c69305"
	],
	"./paglierani/PaglieraniTask": [
		"d375"
	],
	"./paglierani/PaglieraniTask.vue": [
		"d375"
	],
	"./paglierani/PaglieraniWidgetHistory": [
		"fee0",
		"chunk-183e6eca"
	],
	"./paglierani/PaglieraniWidgetHistory.vue": [
		"fee0",
		"chunk-183e6eca"
	],
	"./paglierani/Quotations": [
		"bf20",
		"chunk-183e6eca",
		"chunk-86ed2f2a"
	],
	"./paglierani/Quotations.vue": [
		"bf20",
		"chunk-183e6eca",
		"chunk-86ed2f2a"
	],
	"./paglierani/Uploads": [
		"a1b6",
		"chunk-183e6eca",
		"chunk-601a58b0"
	],
	"./paglierani/Uploads.vue": [
		"a1b6",
		"chunk-183e6eca",
		"chunk-601a58b0"
	],
	"./spiagge/CustomerDetails": [
		"eb47",
		"chunk-a299f4c4"
	],
	"./spiagge/CustomerDetails.vue": [
		"eb47",
		"chunk-a299f4c4"
	],
	"./spiagge/SpiaggeTask": [
		"10e8"
	],
	"./spiagge/SpiaggeTask.vue": [
		"10e8"
	],
	"./spiagge/YourBeachCreate": [
		"b8f2",
		"chunk-09b51cd4"
	],
	"./spiagge/YourBeachCreate.vue": [
		"b8f2",
		"chunk-09b51cd4"
	],
	"./spiagge/YourFoodCreate": [
		"713b",
		"chunk-09c0db19"
	],
	"./spiagge/YourFoodCreate.vue": [
		"713b",
		"chunk-09c0db19"
	],
	"./vircos/PictureDrawer": [
		"3079",
		"chunk-3fe43edb"
	],
	"./vircos/PictureDrawer.vue": [
		"3079",
		"chunk-3fe43edb"
	],
	"./vircos/PictureViewer": [
		"7287",
		"chunk-588211a8"
	],
	"./vircos/PictureViewer.vue": [
		"7287",
		"chunk-588211a8"
	],
	"./vircos/ProjectQRCode": [
		"b52a",
		"chunk-7d4e2a1d"
	],
	"./vircos/ProjectQRCode.vue": [
		"b52a",
		"chunk-7d4e2a1d"
	],
	"./vircos/VircosCalendar": [
		"0def",
		"chunk-71d728b6"
	],
	"./vircos/VircosCalendar.vue": [
		"0def",
		"chunk-71d728b6"
	],
	"./vircos/VircosCutting": [
		"d977",
		"chunk-603ed236"
	],
	"./vircos/VircosCutting.vue": [
		"d977",
		"chunk-603ed236"
	],
	"./vircos/VircosData": [
		"d44f",
		"chunk-2f8bad4d"
	],
	"./vircos/VircosData.vue": [
		"d44f",
		"chunk-2f8bad4d"
	],
	"./vircos/VircosDelivery": [
		"5c71",
		"chunk-42c07c6a"
	],
	"./vircos/VircosDelivery.vue": [
		"5c71",
		"chunk-42c07c6a"
	],
	"./vircos/VircosDocumentPrint": [
		"298d",
		"chunk-2f45f560"
	],
	"./vircos/VircosDocumentPrint.vue": [
		"298d",
		"chunk-2f45f560"
	],
	"./vircos/VircosFinishing": [
		"c73d",
		"chunk-4f10aab8"
	],
	"./vircos/VircosFinishing.vue": [
		"c73d",
		"chunk-4f10aab8"
	],
	"./vircos/VircosGraphics": [
		"afda",
		"chunk-b1834a84"
	],
	"./vircos/VircosGraphics.vue": [
		"afda",
		"chunk-b1834a84"
	],
	"./vircos/VircosGraphics2": [
		"7076",
		"chunk-7594a84e"
	],
	"./vircos/VircosGraphics2.vue": [
		"7076",
		"chunk-7594a84e"
	],
	"./vircos/VircosLab": [
		"cb45",
		"chunk-211ccb0e"
	],
	"./vircos/VircosLab.vue": [
		"cb45",
		"chunk-211ccb0e"
	],
	"./vircos/VircosMaterials": [
		"02ce",
		"chunk-b8047764"
	],
	"./vircos/VircosMaterials.vue": [
		"02ce",
		"chunk-b8047764"
	],
	"./vircos/VircosMeasures": [
		"2b17",
		"chunk-0df89890",
		"chunk-588211a8"
	],
	"./vircos/VircosMeasures.vue": [
		"2b17",
		"chunk-0df89890",
		"chunk-588211a8"
	],
	"./vircos/VircosMeasuresSheet": [
		"3fab",
		"chunk-28da8258"
	],
	"./vircos/VircosMeasuresSheet.vue": [
		"3fab",
		"chunk-28da8258"
	],
	"./vircos/VircosPrintHeader": [
		"888c",
		"chunk-5383523a"
	],
	"./vircos/VircosPrintHeader.vue": [
		"888c",
		"chunk-5383523a"
	],
	"./vircos/VircosTasksWidget": [
		"c39b"
	],
	"./vircos/VircosTasksWidget.vue": [
		"c39b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f5c7";
module.exports = webpackAsyncContext;